import React, { useMemo } from "react";

import './App.css';
import {
  HeaderNew,
  Footer,
  Landing,
  Quote1,
  Checkout,
  Payment,
  FailedCheckout,
  Help
} from './custom-components';
import {
  Routes,
  Route,
  useLocation
} from 'react-router-dom';
import CartProvider from './contexts/cart'
import QuotesProvider from './contexts/quotes'
import { Worker } from '@react-pdf-viewer/core';
import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json';

// v6: configure from the Gen 2 backend outputs (idempotent; index.js also configures).
Amplify.configure(outputs);

function useQuery() {
  const { search } = useLocation();
  //console.log('search--->' +JSON.stringify(search));
  return useMemo(() => new URLSearchParams(search)?.get('encp'), [search]);
}

export default function App(props) {
  let query = useQuery();
  //console.log('query--->' +JSON.stringify(query));
  return (
    <div>
      <QuotesProvider>
        <CartProvider>
          <HeaderNew />
          <Routes>
            <Route exact path="/" element={
              <div>
                <Landing key={1}></Landing>
              </div>
            }> </Route>
            <Route path='/quote' element={<Quote1 />}></Route>
            <Route path='/help' element={<Help />}></Route>
            <Route path='/checkout' element={<Checkout />}></Route>
            <Route path='/failedcheckout' element={<FailedCheckout />}></Route>
            <Route path='/paymentstatus' element={<Payment encp={query} />}></Route>
          </Routes>
          <Footer />

        </CartProvider>
      </QuotesProvider>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      </Worker>
    </div>
  );
}
